import React, { useEffect, useState } from 'react';

const timeZone = 'Africa/Johannesburg';
const calendarFormat = new Intl.DateTimeFormat('en-GB', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' });
const dateFormat = new Intl.DateTimeFormat('en-GB', { timeZone, day: 'numeric', month: 'short', year: 'numeric' });
const timeFormat = new Intl.DateTimeFormat('en-GB', { timeZone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });

function captureDate(value) {
  if (value == null || value === '') return null;
  const timestamp = typeof value.seconds === 'number' ? value.seconds * 1000
    : typeof value._seconds === 'number' ? value._seconds * 1000 : value;
  const date = new Date(timestamp);
  return Number.isNaN(date.getTime()) ? null : date;
}

function calendarDay(date) {
  const parts = Object.fromEntries(calendarFormat.formatToParts(date).map(({ type, value }) => [type, value]));
  return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)) / 86400000;
}

export function formatMotionSpottedTime(value, now = Date.now(), compact = false) {
  const date = captureDate(value);
  if (!date) return '';
  const daysAgo = calendarDay(new Date(now)) - calendarDay(date);
  const day = daysAgo === 0 ? 'today' : daysAgo === 1 ? 'yesterday'
    : daysAgo >= 2 && daysAgo <= 10 ? `${daysAgo} days ago` : dateFormat.format(date);
  return compact ? `${day[0].toUpperCase()}${day.slice(1)} · ${timeFormat.format(date)} SAST` : `Spotted: ${day} at ${timeFormat.format(date)} SAST`;
}

export default function MotionSpottedTime({ capturedAt, compact = false }) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const refresh = () => setNow(Date.now());
    const timer = setInterval(refresh, 60000);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  const date = captureDate(capturedAt);
  if (!date) return null;
  return <p className="cr-photo-meta"><time dateTime={date.toISOString()}>{formatMotionSpottedTime(date, now, compact)}</time></p>;
}
